<template>
    <div class="row">
        <div class="col-lg-12">
            <MarketplaceCard />
        </div>
        <div class="col-lg-12">
            <DeliveryCard />
        </div>
    </div>
</template>
<script>
import MarketplaceCard from "./cards/MarketplaceCard.vue";
import DeliveryCard from "./cards/DeliveryCard.vue";

export default {
    name: "OrderStatusesSettingsPage",
    components: {
        MarketplaceCard, DeliveryCard
    }
}
</script>
